import { React, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
//import usMsaAll from '../../../../components/Map/cb_2018_us_cbsa_20m_wkid102004.json1'
import { useGeoState } from '../../../../components/GeoProvider'
import LinkButton from '../../../../components/LinkButton'
import statesMap from '../../../../utils/stateMap'
import getVectorImage from '../../../../utils/getVectorImage'
import styles from './CbsaStats.module.scss'
//import statStyles from './CbsaStat.module.scss'
import statStyles from './SideTableStyles.module.scss'
import Tooltip from '../../../../components/Tooltip'
import Content from '../../../../components/Content'

const Zip3Stat = ({ zip3Data,  chartRef, mapOptions, toggleEnabled }) => {
  const history = useHistory()
  const changePercentage = zip3Data.percentage
  const forecastValue = (zip3Data.datavalue)
  const isChanged = (zip3Data.istrue) 
  // const valueStr = changePercentage.toFixed(2)
  // const needsPad = parseFloat(valueStr) < 10
  // const padded = (needsPad ? '\u2007' : '') + valueStr
  const states = statesMap()

   const handleMouseOver = (element) => {
    let chartCurrent = chartRef.current.chart
    if (chartCurrent !== undefined && chartCurrent !== null) {
      const identifier = element.attributes['geo_id'].value
      const parent = element.attributes['parent'].value

      const point = chartCurrent.series[1].points.find(function (point) {
        const geoIdvalue = point.geoid === identifier

        if (!geoIdvalue) return false

        if (point.geo_parent.includes(',')) {
          const geoArray = point.parent.split(',')
          if (geoArray.includes(parent)) {
            return true
          }
        } else {
          if (point.geo_parent === parent) {
            return true
          }
        }

        return false
      })

      if (point) {
        const originalGeoParent = point.geo_parent
        point.update({ parent: parent }, false) // update without redraw
        chartCurrent.tooltip.refresh(point)
        point.update({ parent: originalGeoParent }, false) // restore original

        // const pointAfterUpdate = Object.assign({}, point);
        // pointAfterUpdate.geo_parent = geoParentValue;
        // pointAfterUpdate && chart.tooltip.refresh(pointAfterUpdate);
      }
      // if (point.parent.includes(',')) {
      //   const geoArray = point.parent.split(',')
      //   if (geoArray.includes(parent)) {
      //     return true
      //   }
      // } else {
      //   if (point.parent === parent) {
      //     return true
      //   }
      // }

      // if (point) {
      //    const originalGeoParent = point.parent;
      //    point.update({ parent : parent }, false); // update without redraw
      //    chartCurrent.tooltip.refresh(point);
      //    point.update({ parent : originalGeoParent }, false); // update without redraw
      // }
    }
  }


  return (
     <div style={{ display: 'flex' }} className={statStyles.Layout}>
      <div
        style={{
          width: '45%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          marginLeft:'15px',
        }}
        title={zip3Data.statenames}
      >
        <LinkButton
          className={statStyles.btn}
          onMouseOver={(e) => handleMouseOver(e.target)}
          onClick={() => {  
            toggleEnabled
              ? history.push(
                  `/FLUZIP3Dashboard/${zip3Data.geo_parent}/ZIP3/${
                    zip3Data.geo_id
                  }`
                )
              : history.push(`/forecasts/Flumap#zip3-${zip3Data.geo_id}`)
          }}
          title={zip3Data.statename}
          parent={zip3Data.geo_parent}
          geo_id={zip3Data.geo_id}
        >
          {zip3Data.statename.length > 10
            ? zip3Data.statename.substring(0, 10) + '...'
            : zip3Data.statename}
        </LinkButton>
      </div>
      {/* Rate column */}
      <div className={statStyles.columnRate}>{zip3Data.datavalue}</div>

      {/* Change column */}
      <div className={statStyles.columnDays}>
        <span> {getVectorImage(isChanged)} </span>
        <span
          className={
            isChanged ? statStyles.percentageRed : statStyles.percentageGreen
          }
        >
          {' '}
          {changePercentage}%
        </span>
      </div>
    </div>
  )
}

const Zip3Stats = ({ zip3SearchData, zip3Data,  chartRef, mapOptions, toggleEnabled }) => {
  const { displayDate, searchFilter, setSearchFilter } = useGeoState()
  const toggleRef = useRef(null)
  const history = useHistory()
  const states = statesMap()
  const [getFilter, setfilter] = useState('down')
  const inputRef = useRef(false)
  let isCancelled = useRef(false)

  // useEffect(() => {
  //   toggleRef.current = toggleEnabled
  // }, [toggleEnabled])

  function sortStatesByForecastValue(obj, direction = 'asc') {
    if (!obj || typeof obj !== 'object') return obj

    const entries = Object.entries(obj)
    const isStateCode = (key) => /^[A-Z]{2}$/.test(key)

    const metaEntries = []
    const stateEntries = []
    const nonNumericStateEntries = []

    for (const [key, value] of entries) {
      if (!isStateCode(key)) {
        metaEntries.push([key, value])
        continue
      }

      const fv = value?.forecast_value
      if (typeof fv === 'number' && Number.isFinite(fv)) {
        stateEntries.push([key, value])
      } else {
        nonNumericStateEntries.push([key, value])
      }
    }

    // Sort by forecast_value
    stateEntries.sort((a, b) => {
      const av = a[1].forecast_value
      const bv = b[1].forecast_value
      return direction === 'desc' ? bv - av : av - bv
    })

    const sortedObj = Object.fromEntries([
      ...metaEntries,
      ...stateEntries,
      ...nonNumericStateEntries,
    ])

    return sortedObj
  }

  const sortBy = (action) => {
    const statesObj = zip3Data[displayDate]
    if (action === 'up') {
      setfilter('down')
      // stateData[displayDate].sort((a, b) => b.datavalue - a.datavalue)
      zip3Data[displayDate] = sortStatesByForecastValue(statesObj, 'asc')
    } else if (action === 'down') {
      setfilter('up')
      //stateData[displayDate].sort((a, b) => a.datavalue - b.datavalue)
      zip3Data[displayDate] = sortStatesByForecastValue(statesObj, 'desc')
    }
  }
  const [btnSearchLocation, setBtnSearchLocation] = useState(false)

  if (Object.keys(zip3Data).length === 0) return
  const zip3DataForDisplayDate = Object.entries(zip3Data)
  const aboutText =
    'The Prediction Interval Accuracy is defined in terms of how often the forecasted prediction interval contains the true Actual value (Last Flu Season).'

  const mappedZip3Data = zip3DataForDisplayDate.map((zip3) => {  
    let zip3Name = zip3[0].statename ?? ''     
    return { ...zip3[1], name: zip3Name, identifier: zip3[0] }
  })

  const handleChange = (event) => {
    setSearchFilter(event.target.value)
  }
 
  let filteredZip3Data = mappedZip3Data
  if (searchFilter !== '') {
    filteredZip3Data = mappedZip3Data.filter((zip3) => {
      if (
        zip3.name &&
        zip3.name.toLowerCase().includes(searchFilter.toLowerCase())
      ) {
        return zip3
      }
    })
  }
  // filteredZip3Data = filteredZip3Data.filter((zip3) => {
  //   if (zip3.name && zip3.name.length > 1) {
  //     return zip3
  //   }
  // })
  function showSearch() {
    isCancelled.current = true
    btnSearchLocation ? setBtnSearchLocation(false) : setBtnSearchLocation(true)
    btnSearchLocation ? setSearchFilter('') : (inputRef.current = false)
  }
  return (
    <div className={styles.base}>
      <div className={styles.header}>
        <div
          style={{
            width: '100%', //'95%',
            justifyContent: 'flex-start',
          }}
        >
          <div style={{ display: 'flex' }}>
            <div
              style={{
                display: 'inline-flex',
                width: '70%',
              }}
            >
              <span>
                <h5
                  style={{
                    fontFamily: 'graphik',
                    fontSize: '21px',
                    fontWeight: '600',
                    color: '#002677',
                  }}
                >
                  State and Zip3 Incidence
                </h5>
              </span>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '30%',
                justifyContent: 'right',
              }}
            >
              <span onClick={showSearch}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.3584 10.8862L18 17.01L17.0701 18L10.3724 11.7859C9.26916 12.7439 8.21615 13.0355 6.64841 13.0355C3.10647 13.0355 0.203247 10.1323 0.203247 6.59032C0.203247 3.04838 3.10647 0.145157 6.64841 0.145157C10.1903 0.145157 13.0936 3.04838 13.0936 6.59032C13.0936 8.36129 12.5197 9.7249 11.3584 10.8862ZM6.78389 1.45483C4.03637 1.45483 1.78389 3.70175 1.78389 6.44249C1.78389 9.20792 4.03637 11.4548 6.78389 11.4548C9.53142 11.4548 11.7839 9.18323 11.7839 6.44249C11.7839 3.70175 9.53142 1.45483 6.78389 1.45483Z"
                    fill="#E40046"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            style={{
              fontSize: '12px',
              display: 'flex',
              lineHeight: '16px',
              padding: '1rem 0rem 0px',
            }}
          >
            <span style={{ marginLeft: '5px' }}>
              {' '}
              <Tooltip placement="top" iconHeight="15" iconWidth="15">
                <Content maxWidth="300px" fontSize="12px">
                  <p>{aboutText}</p>
                </Content>
              </Tooltip>
            </span>
            &nbsp; Rate represents the incidence of flu within the population in
            a given week. Change indicates the difference in flu incidence since
            the previous week.{' '}
          </div>
          {btnSearchLocation ? (
            <input
              ref={inputRef}
              type="text"
              onChange={handleChange}
              placeholder="Filter Zip3 Areas"
            />
          ) : null}
        </div>
   <div
            style={{
              padding: '0rem 0rem',
              paddingBottom: '0.5rem',
              paddingTop: '0.5rem',
              borderTop: '1px solid #CBCCCD',
              borderBottom: '2px solid #002677',
              marginTop: '5px',
            }}
          >
            <div style={{ display: 'inline-flex', width: '44%' }}>
              <h4>Zip3 </h4>
            </div>
            <div
              style={{
                display: 'inline-flex',
                // width: '26%',
                justifyContent: 'flex-middle',
                cursor: 'pointer',
              }}
            >
              <h4 onClick={() => sortBy(getFilter)}>
                Rate {getVectorImage(getFilter)}
              </h4>
            </div>
            <div
              style={{
                display: 'inline-flex',
                width: '30%',
                justifyContent: 'flex-middle',
              }}
            >
              <h4 style={{
                marginLeft: '38px'
              }}>Change</h4>
            </div>
          </div>
      </div>
      <div style={{ overflow: 'scroll', height: '100%' }}>
        {filteredZip3Data
          // .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((zip3) => {
            return (
              <Zip3Stat
                zip3Data={zip3}
                key={zip3.geo_id}
                chartRef={chartRef}
                mapOptions={mapOptions}
                toggleEnabled={toggleEnabled}
              />
            )
          })}
      </div>
    </div>
  )
}

export default Zip3Stats
